import {
  SET_UPLOADFORMPHD_PAGE2,
  CLEAR_UPLOADFORM_PAGE2,
  SET_UPLOADFORMPOSTDOC_PAGE2
} from "./types";

export const setUploadFormPhDPage2 = (page) => ({
  type: SET_UPLOADFORMPHD_PAGE2,
  payload: page
});

export const setUploadFormPostDocPage2 = (page) => ({
  type: SET_UPLOADFORMPOSTDOC_PAGE2,
  payload: page
});

export const clearUploadFormPage2 = () => ({
  type: CLEAR_UPLOADFORM_PAGE2
});
